import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map, retry } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { Participant } from './../../../variables/participant';

@Injectable({
  providedIn: 'root',
})
export class GetparticipantService {
  private participantSource = new BehaviorSubject(Participant);
  currentParticipant = this.participantSource.asObservable();

  constructor(private http: HttpClient) {}

  getparticipant(qrnumber: string) {
    var client_id=localStorage.getItem('global_client_id')
    return this.http
      .post<Participant>(`${environment.apiUrl}/participant/participant_get.php`, {
        qrnumber, client_id
      })
      .pipe(
        map((data: any) => {
          this.participantSource.next(data);
          return data;
        }),
        retry(3)
      );
  }
}

//return this.http.post<any>(`${environment.apiUrl}/api_login.php`, {

// https://jasonwatmore.com/post/2020/07/06/angular-10-communicating-between-components-with-observable-subject
// https://www.techiediaries.com/angular-10-tutorial-example-rest-crud-http-get-httpclient/
// https://www.djamware.com/post/5da31946ae418d042e1aef1d/angular-8-tutorial-observable-and-rxjs-examples

// https://www.tektutorialshub.com/angular/angular-observable-map-operator/
// https://codecraft.tv/courses/angular/http/http-with-observables/
// https://vegibit.com/how-to-make-http-requests-in-angular-using-observables/
// https://www.djamware.com/post/5da31946ae418d042e1aef1d/angular-8-tutorial-observable-and-rxjs-examples

// https://qa.timing.mobi/timing/scan/api_angular/participant.php
